import { Box } from '@mui/material';
import { renderComponent } from '../../helpers/component-renderer';
import { ENV } from '../../constants';

const DEFAULT_BANNER_URL = `${ENV.CDN_BASE_URL_IMAGES}/content-pages-dropdown.jpg`;

const ImageBlock = ({ imagePosition, imageSrc, textComponents }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: imagePosition === 'left' ? 'row' : 'row-reverse',
      justifyContent: 'center',
      minHeight: { lg: '680px', xl: '500px' },
      my: { lg: 2 },
    }}
    data-testid='image-block-container'
  >
    <Box
      sx={{
        width: '50%',
        backgroundImage: `url(${imageSrc || DEFAULT_BANNER_URL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        display: { xs: 'none', lg: 'block' },
      }}
      data-testid='image-block'
    />
    <Box sx={{ width: { lg: '50%' }, px: { lg: 5 } }}>
      {textComponents.map((component, index) =>
        renderComponent(component, index)
      )}
    </Box>
  </Box>
);

export default ImageBlock;
